import * as React from "react";
import CircularProgress from "@mui/material/CircularProgress";
import Box from "@mui/material/Box";

export default function CircularIndeterminate({
  color = "white",
  size = "20px",
}) {
  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        marginLeft: "5px",
      }}
    >
      <CircularProgress size={size} sx={{ color }} />
    </Box>
  );
}
